import { BNStack } from "@bn-monorepo/js-packages";
import { Avatar, Link, Typography } from "@mui/material";
import { useContext } from "react";
import { SettingsContext } from "../../../../../settingsContext";
import Media from "../../../../CmsComponents/Media/Media";
import { ArticleAuthor } from "../../SectionPage";

interface Props {
  author?: ArticleAuthor;
}

export const AuthorByline: React.FC<Props> = ({ author }) => {
  const { localization } = useContext(SettingsContext);
  if (!author?.name) {
    return null;
  }
  const { name, photo } = author;
  return (
    <BNStack
      direction={"row"}
      data-uit="article-author-byline"
      sx={{
        alignItems: "center",
        gap: 1.5,
        mt: 2,
      }}
    >
      {photo && (
        <Avatar sx={{ width: "5.6rem", height: "5.6rem" }}>
          <Media AltText={name} imagePath={photo.url} noWrapper width={56} height={56} maxWidth={112} />
        </Avatar>
      )}
      <BNStack>
        <Typography
          sx={{
            fontWeight: "bold",
          }}
        >
          {localization.publishInfo_WrittenBy}:
        </Typography>
        <Link href="#author">{name}</Link>
      </BNStack>
    </BNStack>
  );
};
